var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 819,
    height: 819,
    viewBox: "0 0 819 819",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 819,
    height: 819,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.582 380.28C390.804 380.28 373.516 386.776 359.842 397.637V278.46H329.238V540.524H359.842V523.167C373.516 534.027 390.804 540.524 409.582 540.524C453.762 540.524 489.705 504.581 489.705 460.402C489.705 416.223 453.762 380.28 409.582 380.28ZM409.582 510.477C383.921 510.477 362.71 491.073 359.842 466.167V454.636C362.71 429.73 383.921 410.327 409.582 410.327C437.194 410.327 459.658 432.79 459.658 460.402C459.658 488.014 437.194 510.477 409.582 510.477Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 390.442,
    y: 278.46,
    width: 30.606,
    height: 30.606,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonogram);
export default __webpack_public_path__ + "static/media/monogram.309cf3034ad3eb5190c6d3be7ea5fa45.svg";
export { ForwardRef as ReactComponent };